const IConstants = {
    googleMapsAPIKey: "AIzaSyBBl0sKsT4HP-YGy7WIeX6_5Km8wUHYTns"
}

export default IConstants;